<aside class="sidebar" [class.sidebar--collapsed]="collapsed">
  <div class="sidebar__brand">
    <div class="sidebar__brand-mark">SSC</div>
    @if (!collapsed) {
      <div class="sidebar__brand-copy">
        <h2>SSC AI Translation PoC</h2>
        <p>Model Review Management Platform</p>
      </div>
    }
  </div>

  <nav class="sidebar__nav" aria-label="Dashboard navigation">
    @for (item of items; track item.route) {
      <button
        type="button"
        class="sidebar__item"
        routerLinkActive="sidebar__item--active"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="item.route"
        [title]="collapsed ? item.label : ''"
      >
        <span class="sidebar__dot" aria-hidden="true"></span>
        @if (!collapsed) {
          <span class="sidebar__label">{{ item.label }}</span>
        }
      </button>
    }
  </nav>
</aside>
